/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {DropMenuEl} from 'common/components/drop-menu';
import {TooltipEl} from 'common/components/tooltip';
import {SelectEl} from 'common/components/select';
import {InputEl} from 'common/components/input';
import {ButtonEl} from 'common/components/button';
import type {BucketSize} from 'common/widgets/bucket-sizes/index';
import {ButtonTheme} from 'common/components/button/constants';
import {DisplayType} from 'common/components/tooltip/types';
import {Directions} from 'common/components/drop-menu/types';

export function template(this: BucketSize) {
  const {buckets, tooltipErrorMsg} = this.state;
  const {t} = this.getContext(`i18n`);

  return (
    <DropMenuEl
      attrs={{
        open: true,
        direction: Directions.Down,
      }}
      on={{
        change: this.helpers.menuChange as any,
      }}
      props={{positionParent: this}}
    >
      <div sel='.mp-bucket-size'>
        <div sel='.mp-bucket-size-header'>
          {tooltipErrorMsg && (
            <TooltipEl
              attrs={{
                'always-show': true,
                'hide-arrow': true,
                type: DisplayType.Error,
              }}
            >
              {tooltipErrorMsg}
            </TooltipEl>
          )}
          <div sel='.mp-bucket-size-title'>{this.attr(`header`)}</div>
          <div sel='.mp-bucket-size-selection-row'>
            <div sel='.mp-bucket-size-label'>{t(`query-builder.retention.interval.custom-menu.bracket-by`)}</div>
            <SelectEl
              attrs={{
                'min-width': 100,
              }}
              props={this.helpers.getUnitSelectorProps()}
              on={{change: this.helpers.handleChangeUnitSelector}}
            />
          </div>
        </div>
        <div sel='.mp-bucket-size-content-wrapper'>
          <div sel='.mp-bucket-size-content'>
            {buckets.map((bucket, index) => (
              <>
                <div sel='.mp-bucket-size-label'>
                  {t(`query-builder.retention.interval.custom-menu.bracket-number`, {number: index + 1})}
                </div>
                <InputEl
                  sel='.mp-bucket-size-input'
                  attrs={{
                    type: `number`,
                    'auto-focus': index === 0,
                    'validation-status': this.helpers.isBucketValid(index) ? `` : `invalid`,
                    min: `0`,
                  }}
                  on={{
                    input: (ev: any) => this.helpers.changeBracketIntervalInput(ev, index),
                  }}
                  hook={{
                    insert: (vnode) => this.helpers.insertBucketSizeInput(vnode, index),
                  }}
                  props={{
                    value: bucket.interval?.toString() || ``,
                  }}
                />
                <div sel='.mp-bucket-size-label.mp-bucket-size-label-unit'>{bucket.label}</div>
                {!this.helpers.isBucketValid(index) && <div sel='.mp-bucket-size-error-message'>{bucket.errorMsg}</div>}
              </>
            ))}
          </div>
        </div>
        <div sel='.mp-bucket-size-button-row'>
          <ButtonEl
            attrs={{
              theme: ButtonTheme.Secondary,
            }}
            on={{click: this.helpers.cancelBucketSizes}}
          >
            Cancel
          </ButtonEl>
          <ButtonEl
            attrs={{
              theme: ButtonTheme.Primary,
              disabled: !!tooltipErrorMsg || buckets.length === 1,
            }}
            on={{click: this.helpers.applyBucketSizes}}
          >
            Apply
          </ButtonEl>
        </div>
      </div>
    </DropMenuEl>
  );
}
